import React from 'react';

export default function HealthCuesLogo({ size = 34 }) {
  return (
    <img
      src="/healthcues-logo.png"
      alt="HealthCues"
      width={size}
      height={size}
      style={{ flexShrink: 0, objectFit: 'contain' }}
    />
  );
}
